import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../components/Modal';
import useOrders from '../../../../hooks/useOrders';
import { Button, DialogActions, TextField } from '@mui/material';
import orders from '../../../../services/api/orders/orders';
import useProfile from '../../../../hooks/useProfile';

interface Props {
  open: boolean;
  onClose: () => void;
  orderId: string;
  handleSetStatus: (
    table_id: string,
    status_id: number,
    isPickedUp?: boolean,
  ) => void;
  statusId?: number;
  setAddCourierModal?: (
    value: ((prevState: boolean) => boolean) | boolean,
  ) => void;
  activeDelivererId?: string;
  setPreparationAlarmValue: (
    value: ((prevState: number) => number) | number,
  ) => void;
  preparationAlarmValue: number;
}

function CookingAlarm({
  open,
  onClose,
  setPreparationAlarmValue: setParentPreparationAlarmValue, // Rename this to avoid conflict
  preparationAlarmValue,
}: Props) {
  const { t } = useTranslation('orders');
  const { enqueueSnackbar } = useSnackbar();
  const { getCancelReasons, useRejectOrder } = useOrders();

  const [cancelReasons, setCancelReasons] = useState<
    { id: string; description: string }[]
  >([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [rejectReasonId, setRejectReasonId] = useState<string>('');
  const { meProfile } = useProfile();

  const handlePreparationAlarmChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setParentPreparationAlarmValue(Number(event.target.value));
  };

  const handleSetAlarm = async () => {
    if (!meProfile?.activeBranch?.id) {
      enqueueSnackbar('Branch ID is missing', { variant: 'error' });
      return;
    }

    try {
      await orders.updateBranchSettings(
        meProfile.activeBranch.id,
        preparationAlarmValue,
      );

      enqueueSnackbar('Alarm successfully set', { variant: 'success' });
      onClose();
    } catch (error) {
      enqueueSnackbar('Failed to set alarm', { variant: 'error' });
    }
  };

  const handleExtraAction = async () => {
    if (!meProfile?.activeBranch?.id) {
      enqueueSnackbar('Branch ID is missing', { variant: 'error' });
      return;
    }

    try {
      await orders.updateBranchSettings(meProfile.activeBranch.id, 0);
      enqueueSnackbar('Alarm Silindi', { variant: 'success' });
      setParentPreparationAlarmValue(0);
      onClose();
    } catch (error) {
      enqueueSnackbar('Failed to set alarm', { variant: 'error' });
    }
  };

  return (
    <Modal maxWidth="md" open={open} onClose={onClose} title="Pişirme Alarmı">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div>
          Kurye restorana varmadan önce bildirim alın ve yemeği doğru zamanda
          pişirmeye başlayarak müşteriler için yemek sıcaklığını koruyun.
        </div>
        <div style={{ margin: '16px 0' }}>
          <TextField
            label="Dakika"
            type="number"
            InputLabelProps={{
              shrink: true,
            }}
            variant="outlined"
            size="small"
            value={preparationAlarmValue}
            onChange={handlePreparationAlarmChange}
          />
        </div>
      </div>
      {/* Alt butonlar */}
      <DialogActions
        style={{
          justifyContent: 'space-between',
          paddingTop: '30px',
          marginBottom: 0,
          margin: 0,
        }}
      >
        <Button onClick={onClose} color="secondary">
          {t('order.deliverer_modal.close')}
        </Button>
        <div style={{ display: 'flex', gap: '8px' }}>
          <Button onClick={handleExtraAction} variant="outlined">
            Alarmı Sıfırla
          </Button>
          <Button onClick={handleSetAlarm} variant="contained" color="primary">
            Alarmı Kur
          </Button>
        </div>
      </DialogActions>
    </Modal>
  );
}

export default CookingAlarm;
